import Head from "next/head";
import React, { useEffect } from "react";
import { ErrorHandler } from "@business-finland/wif-ui-lib";

import { META_TITLE_SUFFIX } from "@/constants/app";
import { NodeWithIsPreview, SmartEditableArea } from "@/util/SmartEditableArea";

export function ServicePage(
  props: NodeWithIsPreview<Wif.Mgnl.ServicePage>
): JSX.Element | null {
  const { title, metaDescription, type, main, isPreview } = props;
  
  const serviceType = type?.field || "internal";
  const externalUrl = type?.externalUrl;
  // For external pages on public site, redirect to external URL
  useEffect(() => {
    if (serviceType === "external" && externalUrl && !isPreview) {
      window.location.href = externalUrl;
    }
  }, [serviceType, externalUrl, isPreview]);

  return (
    <>
      <Head>
        <title>{title + META_TITLE_SUFFIX}</title>
        <meta name="description" content={metaDescription} />
      </Head>

      {/* Only render main area for internal pages */}
      {serviceType === "internal" && (
        <SmartEditableArea isPreview={isPreview} slotNode={main} />
      )}

      {/* For external pages, show a message */}
      {serviceType === "external" && (isPreview || !externalUrl) && (
        <ErrorHandler
          title="External Service Page"
          description={`This page is configured as "external" - content area is hidden on the public site. Only metadata (title, description, image) is used for listings. External URL: ${externalUrl || "missing"}`}
          videoSrc="/static/videos/Icon_Robot.mp4"
          fallbackSrc="/static/images/Icon_Robot.svg"
        />
      )}
    </>
  );
} 